var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35355 0.646408C4.15829 0.451146 3.84171 0.451146 3.64645 0.646408L0.464466 3.82839C0.269204 4.02365 0.269204 4.34023 0.464466 4.5355C0.659728 4.73076 0.976311 4.73076 1.17157 4.5355L4 1.70707L6.82843 4.5355C7.02369 4.73076 7.34027 4.73076 7.53553 4.5355C7.7308 4.34023 7.7308 4.02365 7.53553 3.82839L4.35355 0.646408ZM4 12.0234H4.5L4.5 0.999962H4H3.5L3.5 12.0234H4Z",
    fill: "#22A112"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.fdfa9eabf0f49268a0c04e16fd4d1ac7.svg";
export { ForwardRef as ReactComponent };